// import React from 'react';
// import ReactECharts from "echarts-for-react";

// const Gauge5 = ({ value, theme }) => {
//     const textColor = theme === "dark" ? "#ffffff" : "#000000"; // White for dark mode, black for light

//     const gaugeOption = {
//         series: [
//             {
//                 type: 'gauge',
//                 startAngle: 180,
//                 endAngle: 0,
//                 center: ['50%', '60%'],
//                 radius: '90%',
//                 min: 0,
//                 max: 100,
//                 splitNumber: 8,
//                 axisLine: {
//                     lineStyle: {
//                         width: 6,
//                         color: [
//                             [0.25, '#FF6E76'],
//                             [0.5, '#FDDD60'],
//                             [0.75, '#58D9F9'],
//                             [1, '#7CFFB2']
//                         ]
//                     }
//                 },
//                 pointer: {
//                     icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
//                     length: '12%',
//                     width: 20,
//                     offsetCenter: [0, '-60%'],
//                     itemStyle: {
//                         color: 'auto'
//                     }
//                 },
//                 axisTick: {
//                     length: 12,
//                     lineStyle: {
//                         color: 'auto',
//                         width: 2
//                     }
//                 },
//                 splitLine: {
//                     length: 20,
//                     lineStyle: {
//                         color: 'auto',
//                         width: 5
//                     }
//                 },
//                 axisLabel: {
//                     color: textColor, // Change text color based on theme
//                     fontSize: 20,
//                     distance: -60,
//                     rotate: 'tangential',
//                     formatter: function (value) {
//                         if (value === 0.875) return 'Grade A';
//                         if (value === 0.625) return 'Grade B';
//                         if (value === 0.375) return 'Grade C';
//                         if (value === 0.125) return 'Grade D';
//                         return '';
//                     }
//                 },
//                 title: {
//                     offsetCenter: [0, '-10%'],
//                     fontSize: 20,
//                     color: textColor // ✅ Change the gauge name color based on theme
//                 },
//                 detail: {
//                     fontSize: 30,
//                     offsetCenter: [0, '-35%'],
//                     valueAnimation: true,
//                     formatter: function (value) {
//                         return value + '';
//                     },
//                     color: 'inherit'
//                 },
//                 data: [
//                     {
//                         value: value ? value : 0,
//                         name: 'Grade Rating'
//                     }
//                 ]
//             }
//         ]
//     };

    

//     return (
//         <div>
//             <ReactECharts option={gaugeOption} />
//         </div>
//     );
// };

// export default Gauge5;


import React from 'react';
import ReactECharts from "echarts-for-react";

const GaugeChart = ({ value, theme ,upperRange,lowerRange,breakRange }) => {
    const textColor = theme === "dark" ? "#ffffff" : "#000000"; // Adjust colors based on theme

    console.log(upperRange,lowerRange,breakRange    )
    const gaugeOption = {
        // title: {
        //     // text: 'Specific Power Consumption (SPC)',
        //     left: 'center',
        //     top: '5%',
        //     textStyle: {
        //         fontSize: 18,
        //         color: textColor
        //     }
        // },
        series: [
            {
                type: 'gauge',
                startAngle: 180,
                endAngle: 0,
                center: ['50%', '55%'],  
                radius: '90%',
                min: lowerRange?lowerRange:0,
                max: upperRange?upperRange:100,
                splitNumber: 3,
                axisLine: {
                    lineStyle: {
                        width: 6,
                        color: [
                            [breakRange / (upperRange ?? 10000), '#7CFFB2'],
                            // [breakRange?breakRange:50, '#7CFFB2'],
                            [upperRange?upperRange:100, '#FF6E76'],
                        ]
                    }
                },
                pointer: {
                    icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                    length: '10%',
                    width: 14,
                    offsetCenter: [0, '-50%'],
                    itemStyle: {
                        color: 'auto',
                    }
                },
                axisTick: {
                    length: 8,
                    lineStyle: {
                        color: 'auto',
                        width: 1
                    }
                },
                splitLine: {
                    length: 12,
                    lineStyle: {
                        color: 'auto',
                        width: 3
                    }
                },
                axisLabel: {
                    color: textColor,
                    fontSize: 15,
                    distance: -30,
                    rotate: 'tangential',
                    formatter: value => value.toFixed(1) // Format to 3 decimal places
                },
                title: {
                    offsetCenter: [0, '30%'],
                    fontSize: 16,
                    color: textColor
                },
                detail: {
                    fontSize: 20,
                    offsetCenter: [0, '-15%'],
                    valueAnimation: true,
                    // formatter: value => value.toFixed(3),
                    color: textColor
                },
                data: [
                    {
                        value: value?value: 0
                    }
                ]
            }
        ]
    };

    return (
        <div>
            <ReactECharts option={gaugeOption} />
        </div>
    );
};

export default GaugeChart;

